var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"auto"}},[_c('pre',{staticClass:"scrollx mb-x4 p-5 ",staticStyle:{"overflow":"visible"},style:({ }),domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }